import React, { useCallback, useState, useEffect } from 'react'
import { Loader, Datagrid } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import { navigate, useParams } from '@reach/router'
import { useDispatch } from 'react-redux'
import { ROUTES } from '_/utils/constants'
import { Grid } from '@material-ui/core'
import { ColumnsWebhook } from '../constants'
import { getWebhooksByAgency } from '_/modules/agency/actions'
import { useToast } from '_/hooks/use-toast'
import useStyles, { datagridStyle } from './styles'

const Webhooks = () => {
  const styles = useStyles()
  const { showToast } = useToast()
  const { agencyId } = useParams()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [webhooks, setWebhooks] = useState([])

  const handleBackNavigation = useCallback(() => {
    return navigate(`${ROUTES.AGENCY}/${agencyId}`)
  }, [navigate, agencyId])

  const handleEditProcedure = useCallback(event => {
    navigate(`${ROUTES.AGENCY}/${agencyId}/webhook/${event.row.id}`)
  }, [])

  const handleCellClick = useCallback(
    (params, event) => {
      if (params.field === 'viewRequests') {
        event.stopPropagation()
        navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_REQUESTS}/${params.row.id}`)
      }
    },
    [agencyId]
  )

  const fetchWebhooks = useCallback(() => {
    setIsLoading(true)
    dispatch(getWebhooksByAgency({ agency: agencyId }))
      .then(data => {
        const filteredWebhooks = (data?.results || []).filter(
          webhook => webhook?.agency?.toString() === agencyId?.toString()
        )
        setWebhooks(filteredWebhooks)
        setIsLoading(false)
      })
      .catch(() => {
        showToast({ type: 'error', message: 'Ocorreu um erro ao buscar os webhooks.' })
        setIsLoading(false)
      })
  }, [dispatch, agencyId, showToast])

  useEffect(() => {
    fetchWebhooks()
  }, [fetchWebhooks, agencyId])

  return (
    <>
      <Loader open={isLoading} hasBackdrop />
      <HeaderTitle title="Webhooks" backButtonAction={handleBackNavigation} />
      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            loading={isLoading}
            rows={webhooks}
            columns={ColumnsWebhook()}
            paginationMode="server"
            sx={datagridStyle}
            onRowClick={handleEditProcedure}
            onCellClick={handleCellClick}
            checkboxSelection={false}
            disableSelectionOnClick
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Webhooks
